module.exports = __webpack_public_path__ + "img/Paxos.180e6703.png";